var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseenter":_vm.submenuOnMouseEnter,"mouseleave":_vm.submenuOnMouseLeave}},[_c('b-nav-item-dropdown',{ref:"dropdown",staticClass:"dropdownContainer",attrs:{"href":_vm.href,"text":_vm.text,"dropright":_vm.dropright,"left":_vm.left}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }